var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dp-bulb"},[_c('div',{ref:"innerElement",class:[
      'dp-bulb__inner',
      ("dp-bulb__inner--" + _vm.state) ],style:(_vm.style)},[_c('span',{staticClass:"dp-bulb__label"},[_vm._v(_vm._s(_vm.text))])]),(_vm.subtitle)?_c('span',{staticClass:"dp-bulb__subtitle"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }